import { SheetTrigger } from '@/components/ui/sheet';
import { UserCircleIcon } from '@heroicons/react/24/outline';
import { useResponsive } from '@/hooks/use-responsive';
import { cn } from '@/lib/utils';

interface LoginSheetProps {
  className?: string;
  isDisabled?: boolean;
  onClick: () => void;
}

export const LoginSheetTrigger = ({
  className,
  isDisabled = false,
  onClick,
}: LoginSheetProps) => {
  const { isDesktop } = useResponsive();
  return (
    <SheetTrigger
      onClick={onClick}
      disabled={isDisabled}
      className={cn('cursor-pointer', className)}
    >
      {isDesktop ? (
        <div className="inline-flex items-center gap-[3px] text-black">
          <UserCircleIcon className="size-5" />
          <span className="text-xs  font-nunito700">Log in</span>
        </div>
      ) : (
        <div className={cn('flex items-center gap-1')}>
          <UserCircleIcon className="text-black size-5 stroke-2" />
          <span className="text-black text-xs md:text-sm font-nunito700">
            Login
          </span>
        </div>
      )}
    </SheetTrigger>
  );
};
